/**
 * Tags an update that loads content rather than editing it: the first load, a language switch, `setContent`.
 * - Lets features tell content that was already there from content the user just added (e.g. mentions).
 */
export const CONTENT_LOAD_TAG = 'pbk-content-load';
